'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = require('../actionTypes');

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { ethExchangeRates: {}, catExchangeRates: {}, currencyCode: 'usd' };
  var action = arguments[1];
  var type = action.type;

  switch (type) {
    case _actionTypes.ETH_EXCHANGE_RATES_FETCHED:
      return _extends({}, state, {
        ethExchangeRates: action.ethExchangeRates
      });

    case _actionTypes.ETH_EXCHANGE_RATES_LOCALLY_LOADED:
      return _extends({}, state, {
        ethExchangeRates: action.ethExchangeRates
      });

    case _actionTypes.CAT_EXCHANGE_RATES_FETCHED:
      return _extends({}, state, {
        catExchangeRates: action.catExchangeRates
      });

    case _actionTypes.CAT_EXCHANGE_RATES_LOCALLY_LOADED:
      return _extends({}, state, {
        catExchangeRates: action.catExchangeRates
      });

    case _actionTypes.CURRENCY_CODE_CHANGED:
      return _extends({}, state, {
        currencyCode: action.currencyCode
      });

    case _actionTypes.CURRENCY_CODE_LOCALLY_LOADED:
      return _extends({}, state, {
        currencyCode: action.currencyCode
      });

    default:
      return state;
  }
};

exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/reducers/currencyExchangeRates.js
// module id = 1317
// module chunks = 0